var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb',{attrs:{"separator":">"}},_vm._l((_vm.routeList),function(item){return _c('a-breadcrumb-item',{key:item.path},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }